export default __webpack_public_path__ + "static/media/git-scm-icon.6d27b5e0.svg";